import { TypeAnimation } from "react-type-animation";
import { Col, Container, Row } from "../../Tools/Grid-system";
import image from "../../images/logo.png";
import ContactIcons from "../ContactIcons/ContactIcons";
import MainButton from "../Buttons/MainButton";
import { useContextHook } from "../../Context/ContextOPen";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const naviget = useNavigate();
  useEffect(() => {
    AOS.init();
  }, []);
  const { swiperIndex, content, direction, setSwiperIndex } = useContextHook();
  return (
    <div style={{ direction: direction }}>
      <Container>
        <Row className="items-center h-[93dvh]">
          <Col md={6} className="space-y-8 transition-all max-lg:order-2">
            <div className={swiperIndex === 0 || !swiperIndex ? "hero" : ""}>
              <h1 className=" text-4xl max-sm:text-2xl font-bold mb-4">
                {content.WelcomeTo}
              </h1>
              <h1 className=" text-2xl font-bold mb-4 text-Main space-x-2">
                {content.OurServices + " "}
                {content.website && content.Design && (
                  <TypeAnimation
                    sequence={[
                      content.website,
                      2000,
                      content.IOSApplication,
                      2000,
                      content.AndroidApplication,
                      2000,
                      content.Design,
                      2000,
                      content.VoiceOver,
                      2000,
                      content.Blender,
                      2000,
                      content.ArchitectureDesign,
                      2000,
                      content.logo,
                      2000,
                    ]}
                    wrapper="span"
                    speed={60}
                    style={{ fontSize: "1em" }}
                    repeat={Infinity}
                  />
                )}
              </h1>
              <p className="leading-7 text-lg mb-5">
                {content.heroDescription}
              </p>
              <ContactIcons index={0} />
              <MainButton
                onClick={() => {
                  naviget("/contact-us");
                  setSwiperIndex(4);
                }}
                name={content.ContactUs}
                className="my-4"
                index={0}
              />
            </div>
          </Col>
          <Col
            md={6}
            className="flex justify-center items-center max-lg:order-1 max-lg:!mt-3"
          >
            <img
              data-aos="zoom-in"
              data-aos-delay="50"
              data-aos-duration="1000"
              src={image}
              alt=""
              className="max-md:w-1/2"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Hero;
